import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 20px;
  border-top: 1px solid ${(props) => props.theme.$gray300};

  .shell {
    margin-top: 0;
  }

  .market-filters {
    display: flex;
    align-items: center;
    gap: 8px 18px;
    flex-wrap: wrap;
    margin-top: 14px;
    padding: 12px 18px;
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);

    .filter-label {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 0.82rem;
      color: ${(props) => props.theme.$gray600};

      i {
        font-size: 16px;
      }
    }

    .selecao {
      min-width: 220px;
      max-width: 360px;
      flex: 1;

      .pi-select__control {
        border-color: ${(props) => props.theme.$gray300};
        min-height: 34px;
        font-size: 0.85rem;

        &--is-focused {
          border-color: ${(props) => props.theme.$primary_green};
          box-shadow: 0 0 0 0.2rem rgba(0, 159, 121, 0.15);
        }
      }

      .pi-select__single-value {
        color: ${(props) => props.theme.$gray800};
      }

      .pi-select__menu {
        z-index: 50;
      }
    }

    .palavra {
      display: flex;
      flex: 1;
      min-width: 260px;
      max-width: 420px;
      margin: 0;

      .form-control {
        font-size: 0.85rem;
        height: 34px;
        border-color: ${(props) => props.theme.$gray300};

        &:focus {
          border-color: ${(props) => props.theme.$primary_green};
          box-shadow: 0 0 0 0.2rem rgba(0, 159, 121, 0.15);
        }
      }

      .btn {
        font-size: 0.82rem;
      }
    }

    .modo {
      width: auto;
      height: 34px;
      font-size: 0.85rem;
    }
  }

  .market-refino {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin: 10px 0 0;
    font-size: 0.8rem;
    color: ${(props) => props.theme.$gray600};

    .material-icons {
      font-size: 16px;
      color: ${(props) => props.theme.$primary_green};
    }
  }

  .market-empty {
    margin-top: 14px;
    padding: 16px 18px;
    border-radius: 10px;
    border: 1px solid ${(props) => props.theme.$gray300};
    background: #fff;
    color: ${(props) => props.theme.$gray700};
    font-size: 0.88rem;
  }

  .carregando {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 0;
    font-size: 0.84rem;
    color: ${(props) => props.theme.$gray500};
  }

  .charts-grid .wide {
    grid-column: 1 / -1;
  }

  .region-row.larga .region-name {
    width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .samples-card + .samples-card {
    margin-top: 14px;
  }

  .sintese-cell {
    min-width: 280px;
    max-width: 560px;
    color: ${(props) => props.theme.$gray700};

    .sintese-text {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .num-cell {
    text-align: center;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  .samples-footer .pagination {
    margin: 0;
  }

  @media print {
    .market-filters {
      display: none;
    }
  }
`;
